import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { View, Text, StyleSheet } from 'react-native'
import { Spacer } from '@linqpal/components/src/ui'
import {
  ITransactionItem,
  TransactionTimelineItem,
} from './PaymentHistoryTimelineItem'

export const PaymentHistory = observer(({ transactions, totalAmount }) => {
  const { t } = useTranslation('global')

  const plan = useMemo(
    () =>
      [...transactions].sort(
        (a: ITransactionItem, b: ITransactionItem) =>
          new Date(b.date).getTime() - new Date(a.date).getTime(),
      ),
    [transactions],
  )

  const isFullPayment =
    transactions?.length === 1 &&
    transactions[0].amount + transactions[0].fee === totalAmount

  return (
    <>
      <View style={{ paddingLeft: 5 }}>
        <Text style={styles.title}>
          {t('PaymentHistoryInvoice.paymentHistory')}
        </Text>
        <Spacer height={20} />

        <View style={styles.transactionsLayout}>
          {plan.map((p, idx) => (
            <TransactionTimelineItem
              key={idx}
              oneTransaction={plan.length === -1}
              transaction={p}
              isLastTransaction={plan.length === idx}
              isFullPayment={isFullPayment}
            />
          ))}
        </View>
      </View>
    </>
  )
})

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Inter',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 28,
    color: '#19262F',
  },
  transactionsLayout: {
    marginBottom: 30,
  },
})
